import React from 'react';
import Hero from '../components/Hero';
import Services from '../components/Services';
import About from '../components/About';
import Contact from '../components/Contact';
import SEO from '../components/SEO';

const Home: React.FC = () => {
  return (
    <>
      <SEO title="Digital Marketing & AI Automation Agency" description="From websites that convert to AI workflows that save time—we deliver digital solutions that grow your business. No jargon. No complexity. Just results." path="/" />
      <Hero />
      <Services />
      <About />
      <Contact />
    </>
  );
};

export default Home;